// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export const PatientSurveyAPI = {
    /**
     * Retrieves a list of surveys.
     */
    GetSurveyList(fn, req) {
        return fn(`/patient-survey/v1/surveys?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Retrieves a list of submissions for selected business groups.
     */
    GetSubmissions(fn, req) {
        try {
            fm.validateUrlParam(req["surveyId"], "surveyId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/patient-survey/v1/survey/${req["surveyId"]}/submissions?${fm.renderURLSearchParams(req, ["surveyId"])}`, { method: "GET" });
    },
};
